import MaterialTable from 'material-table';
import { defaultGridOptions, useGridColDefs } from '../../utils/GridUtils';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: '1em',
  },
}));

const PurchaseOrderDetailGrid = ({ data, purchaseOrderDate }) => {
  const classes = useStyles();

  const colDefs = useGridColDefs([
    { title: 'Material', field: 'materialName' },
    { title: 'Código', field: 'materialCode' },
    { title: 'Cantidad', field: 'orderQty', valueType: 'numeric', valueRender: (value, rowData) => `${value} ${rowData.measureUnitOrder}` },
    {
      title: 'Cantidad entregada',
      field: 'deliveryQty',
      valueType: 'numeric',
      valueRender: (value, rowData) => `${value} ${rowData.measureUnitDelivery}`,
    },
    {
      title: 'Cantidad pendiente de entrega',
      field: 'deliveryPendingQty',
      valueType: 'numeric',
      valueRender: (value, rowData) => `${value} ${rowData.measureUnitDelivery}`,
    },
  ]);

  return (
    <div className={classes.root}>
      <CustomDatePicker
        style={{ width: 'unset' }}
        disableMinDate
        value={purchaseOrderDate}
        margin="dense"
        readOnly
        label="Fecha del pedido de compra"
      />
      <MaterialTable {...defaultGridOptions} columns={colDefs} data={data} />
    </div>
  );
};

export default PurchaseOrderDetailGrid;
